import React from 'react';
import { twMerge } from 'tailwind-merge';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { segmentTrack } from 'flow/actions/segment-actions';
import Button from 'flow/components/ui-components/Button';
import Icon from 'flow/components/ui-components/Icon';
import MenuItem from 'flow/components/ui-components/MenuItem';
import Tooltip from 'flow/components/ui-components/Tooltip';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import { selectOriginDTOSubtype } from 'flow/selectors/TicketsSelectors';
import { TicketKey } from 'flow/types/EntityKeys';
import { TICKET_STRINGS } from 'flow/utils/segment-utils';

interface Props {
    ticketKey: TicketKey;
    segmentContext: string;
    variant?: 'icon' | 'menuItem';
    className?: string;
}

const SuggestedTagsButton = ({
    ticketKey,
    segmentContext,
    variant = 'icon',
    className,
}: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const { openModal } = useModal();
    const dtoSubtype = useAppSelector((state) =>
        selectOriginDTOSubtype(state, ticketKey),
    );

    const onClick = () => {
        openModal('ticketTags', { ticketKey });

        dispatch(
            segmentTrack(TICKET_STRINGS.TAGS_GENERATE_SUGGESTED, {
                component: `${segmentContext} ${dtoSubtype}`,
            }),
        );
    };

    if (variant === 'menuItem') {
        return (
            <MenuItem onClick={onClick} className={className}>
                <div className="flex items-center gap-x-2">
                    <Icon iconKey="label" />
                    {i18next.t('Tooltip.Suggest.Tags')}
                </div>
            </MenuItem>
        );
    }

    return (
        <Tooltip label={i18next.t('Tooltip.Suggest.Tags')}>
            <Button
                onClick={onClick}
                iconKey="label"
                className={twMerge(
                    'rounded-sm bg-gray-200 hover:bg-gray-300',
                    className,
                )}
            />
        </Tooltip>
    );
};

export default SuggestedTagsButton;
